import React, { useState, useEffect, useCallback } from 'react';
// AuthGate bypassed in CRM

const API = '';  // relative URL through nginx

const SOURCE_LABELS = {
  government_decisions: 'Διαύγεια - Αποφάσεις',
  diavgeia: 'Διαύγεια',
  supreme_court_full: 'Άρειος Πάγος',
  supreme_court: 'Άρειος Πάγος (Παλαιές)',
  areiospagos_poinikes: 'Άρειος Πάγος (Ποινικές)',
  eurlex_legislation: 'EUR-Lex Νομοθεσία',
  eu_legislation: 'Ευρωπαϊκή Νομοθεσία',
  administrative_court: 'Διοικητικά Δικαστήρια',
  ste_council_of_state: 'Συμβούλιο Επικρατείας (ΣτΕ)',
  adjustice_court: 'ΣτΕ (adjustice.gr)',
  'adjustice.gr': 'ΣτΕ (adjustice.gr)',
  aade_egkyklioi: 'ΑΑΔΕ Εγκύκλιοι',
  aade_circulars: 'ΑΑΔΕ Εγκύκλιοι',
  parliament_laws: 'Βουλή - Νόμοι',
  parliament_api: 'Βουλή - Νόμοι',
  hellenic_parliament: 'Βουλή - Νόμοι',
  government_gazette: 'ΦΕΚ - Εφημερίδα Κυβερνήσεως',
  fek_metadata: 'ΦΕΚ',
  court_audit: 'Ελεγκτικό Συνέδριο',
  court_of_audit: 'Ελεγκτικό Συνέδριο',
  greek_laws: 'Ελληνική Νομοθεσία',
  tax_authority: 'Φορολογική Αρχή',
  dpa_decisions: 'Αρχή Προστασίας Δεδομένων',
  interior_ministry: 'Υπ. Εσωτερικών',
};

const SOURCE_COLORS = {
  government_decisions: {bg:'#F0FDF4',color:'#166534',border:'#86EFAC'},
  diavgeia: {bg:'#F0FDF4',color:'#166534',border:'#86EFAC'},
  supreme_court_full: {bg:'#FEF3C7',color:'#92400E',border:'#FCD34D'},
  supreme_court: {bg:'#FEF3C7',color:'#92400E',border:'#FCD34D'},
  areiospagos_poinikes: {bg:'#FEE2E2',color:'#991B1B',border:'#FCA5A5'},
  eurlex_legislation: {bg:'#EDE9FE',color:'#5B21B6',border:'#C4B5FD'},
  eu_legislation: {bg:'#EDE9FE',color:'#5B21B6',border:'#C4B5FD'},
  administrative_court: {bg:'#DBEAFE',color:'#1E40AF',border:'#93C5FD'},
  ste_council_of_state: {bg:'#DBEAFE',color:'#1E40AF',border:'#93C5FD'},
  adjustice_court: {bg:'#DBEAFE',color:'#1E40AF',border:'#93C5FD'},
  'adjustice.gr': {bg:'#DBEAFE',color:'#1E40AF',border:'#93C5FD'},
  aade_egkyklioi: {bg:'#D1FAE5',color:'#065F46',border:'#6EE7B7'},
  aade_circulars: {bg:'#D1FAE5',color:'#065F46',border:'#6EE7B7'},
  parliament_laws: {bg:'#FFF7ED',color:'#9A3412',border:'#FDBA74'},
  parliament_api: {bg:'#FFF7ED',color:'#9A3412',border:'#FDBA74'},
  government_gazette: {bg:'#F5F3FF',color:'#6D28D9',border:'#C4B5FD'},
  court_audit: {bg:'#FDF2F8',color:'#9D174D',border:'#F9A8D4'},
  greek_laws: {bg:'#ECFDF5',color:'#047857',border:'#6EE7B7'},
  tax_authority: {bg:'#FEF2F2',color:'#B91C1C',border:'#FCA5A5'},
};

/* ============ DOCUMENT POPUP ============ */
const DocumentPopup = ({ docId, onClose }) => {
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!docId) return;
    setLoading(true);
    fetch(`${API}/api/search/document/${docId}`)
      .then(r => r.json())
      .then(data => {
        if (data.error) setError(data.error);
        else setDoc(data);
        setLoading(false);
      })
      .catch(e => { setError(e.message); setLoading(false); });
  }, [docId]);

  if (!docId) return null;

  const handlePrint = () => {
    const w = window.open('','_blank');
    w.document.write('<html><head><title>' + (doc?.title || 'Έγγραφο') + '</title>' +
      '<style>body{font-family:Georgia,serif;padding:40px;line-height:1.8;font-size:14px;}' +
      'h1{font-size:18px;} .meta{color:#666;font-size:12px;margin-bottom:20px;}</style></head>' +
      '<body><h1>' + (doc?.title || '') + '</h1>' +
      '<div class="meta">' + (doc?.source || '') + (doc?.decision_number ? ' | ' + doc.decision_number : '') + (doc?.year ? ' | ' + doc.year : '') + '</div>' +
      '<hr/><pre style="white-space:pre-wrap;font-family:Georgia,serif;">' + (doc?.full_text || '') + '</pre></body></html>');
    w.document.close();
    w.print();
  };

  const handleSave = () => {
    const txt = (doc?.title || '') + '\n\n' + (doc?.source || '') + ' | ' + (doc?.decision_number || '') + ' | ' + (doc?.year || '') + '\n\n' + (doc?.full_text || '');
    const blob = new Blob([txt], {type:'text/plain;charset=utf-8'});
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = ((doc?.decision_number || doc?.title || 'document') + '.txt').replace(/[\/]/g,'_');
    a.click();
  };

  const handleEmail = () => {
    const subj = encodeURIComponent(doc?.title || 'Νομικό Έγγραφο');
    const body = encodeURIComponent((doc?.title || '') + '\n\n' + (doc?.source || '') + ' | ' + (doc?.decision_number || '') + '\n\n' + (doc?.full_text || '').substring(0, 5000) + '\n\n---\nΑπό: ΝΟΜΟΚΡΑΤΙΑ.AI');
    window.open('mailto:?subject=' + subj + '&body=' + body);
  };

  return (
    <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={onClose}>
      <div style={{position:'absolute',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.6)',backdropFilter:'blur(4px)'}}/>
      <div style={{
        position:'relative',background:'#FFF',borderRadius:16,width:'90%',maxWidth:900,maxHeight:'90vh',
        display:'flex',flexDirection:'column',boxShadow:'0 25px 50px rgba(0,0,0,0.25)',
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{padding:'20px 24px',borderBottom:'1px solid #E2E8F0',display:'flex',alignItems:'flex-start',justifyContent:'space-between',flexShrink:0}}>
          {loading ? (
            <div style={{fontSize:14,color:'#64748B'}}>⏳ Φόρτωση εγγράφου...</div>
          ) : error ? (
            <div style={{fontSize:14,color:'#DC2626'}}>❌ {error}</div>
          ) : doc && (
            <div style={{flex:1,marginRight:16}}>
              <h3 style={{fontSize:18,fontWeight:700,color:'#1E293B',lineHeight:1.4,marginBottom:8}}>{doc.title}</h3>
              <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
                {doc.source && (
                  <span style={{fontSize:11,padding:'3px 10px',borderRadius:6,background:'#FEF3C7',color:'#92400E',fontWeight:700}}>
                    ⚖️ {doc.source}
                  </span>
                )}
                {doc.decision_number && (
                  <span style={{fontSize:11,padding:'3px 10px',borderRadius:6,background:'#EFF6FF',color:'#2563EB',fontWeight:600}}>
                    📋 {doc.decision_number}
                  </span>
                )}
                {doc.year && (
                  <span style={{fontSize:11,padding:'3px 10px',borderRadius:6,background:'#F0FDF4',color:'#059669',fontWeight:600}}>
                    📅 {doc.year}
                  </span>
                )}
                {doc.text_length && (
                  <span style={{fontSize:11,color:'#94A3B8'}}>
                    {(doc.text_length/1000).toFixed(1)}K χαρακτήρες
                  </span>
                )}
              </div>
            </div>
          )}
          <div style={{display:'flex',gap:6,flexShrink:0,flexWrap:'wrap'}}>
            <button onClick={handlePrint} style={{padding:'8px 14px',borderRadius:8,background:'#F0FDF4',color:'#059669',fontSize:12,fontWeight:600,border:'1px solid #BBF7D0',cursor:'pointer'}}>🖨️ Εκτύπωση</button>
            <button onClick={handleSave} style={{padding:'8px 14px',borderRadius:8,background:'#EFF6FF',color:'#2563EB',fontSize:12,fontWeight:600,border:'1px solid #BFDBFE',cursor:'pointer'}}>💾 Αποθήκευση</button>
            <button onClick={handleEmail} style={{padding:'8px 14px',borderRadius:8,background:'#FEF3C7',color:'#92400E',fontSize:12,fontWeight:600,border:'1px solid #FCD34D',cursor:'pointer'}}>📧 Αποστολή</button>
            {doc?.url && (<button onClick={() => window.open(doc.url, '_blank')} style={{padding:'8px 14px',borderRadius:8,background:'#1E293B',color:'#FFF',fontSize:12,fontWeight:600,border:'none',cursor:'pointer'}}>🔗 Πηγή</button>)}
            <button onClick={onClose} style={{padding:'8px 14px',borderRadius:8,background:'#F1F5F9',color:'#475569',fontSize:12,fontWeight:600,border:'1px solid #E2E8F0',cursor:'pointer'}}>✕ Κλείσιμο</button>
          </div>
          </div>
        {/* Body */}
        <div style={{padding:24,overflowY:'auto',flex:1}}>
          {loading && (
            <div style={{textAlign:'center',padding:40,color:'#94A3B8'}}>
              <div style={{fontSize:40,marginBottom:12}}>⏳</div>
              <div>Φόρτωση πλήρους κειμένου...</div>
            </div>
          )}
          {doc && (
            <div style={{
              fontSize:14,lineHeight:1.8,color:'#1E293B',
              whiteSpace:'pre-wrap',fontFamily:'"Georgia","Times New Roman",serif',
            }}>
              {doc.full_text}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/* ============ MAIN COMPONENT ============ */
const LegalSearch = () => {
  const [query, setQuery] = useState('');
  const [showPricing, setShowPricing] = useState(false);
  const [yearFrom, setYearFrom] = useState('');
  const [yearTo, setYearTo] = useState('');
  const [source, setSource] = useState('');
  const [aiSummary, setAiSummary] = useState(true);
  const [isStreaming, setIsStreaming] = useState(false);
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState(null);
  const [sources, setSources] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [showAllResults, setShowAllResults] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [chatLoading, setChatLoading] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [caseName, setCaseName] = useState('');
  const [savedId, setSavedId] = useState(null);
  const [saveConfirm, setSaveConfirm] = useState('');
  const guardedAction = (fn) => fn(); // bypassed in CRM

  useEffect(() => {
    fetch(API+'/api/search/stats').then(r=>r.json()).then(setStats).catch(()=>{});
    fetch(API+'/api/search/sources').then(r=>r.json()).then(data => {
      if (Array.isArray(data)) setSources(data);
    }).catch(()=>{});
  }, []);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setLoading(true); setError(null); setResults(null); setIsStreaming(true);
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('nomokratia_token');
      const r = await fetch(API+'/api/search/search-stream', {
        method:'POST',
        headers:{'Content-Type':'application/json', 'Authorization': `Bearer ${token}`},
        body: JSON.stringify({
          query: query.trim(),
          year_from: yearFrom ? parseInt(yearFrom) : null,
          year_to: yearTo ? parseInt(yearTo) : null,
          source: source || null,
          limit: 20,
          ai_summary: aiSummary,
        })
      });
      if(r.status===401){setShowPricing(true);setLoading(false);return;}
      if (!r.ok) throw new Error('HTTP '+r.status);
      const reader = r.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let aiText = '';
      while (true) {
        const {done, value} = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, {stream: true});
        const lines = buffer.split('\n');
        buffer = lines.pop();
        for (const line of lines) {
          if (!line.startsWith('data: ')) continue;
          try {
            const evt = JSON.parse(line.slice(6));
            if (evt.type === 'results') {
              setResults({success:true, query:query.trim(), total_results:evt.total, results:evt.results, ai_summary:null});
              setLoading(false);
            } else if (evt.type === 'ai_chunk') {
              aiText += evt.chunk;
              setResults(prev => prev ? {...prev, ai_summary: aiText} : prev);
            } else if (evt.type === 'error') {
              setError(evt.message);
            }
          } catch(e) {}
        }
      }
    } catch(e) { setError(e.message); setLoading(false); setIsStreaming(false); }
    setLoading(false); setIsStreaming(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') guardedAction(handleSearch);
  };


  /* Render inline: bold, doc refs, article refs */
  const renderInline = useCallback((text) => {
    if (!text) return null;
    /* Normalize 📄 **ΕΓΓΡΑΦΟ X** and 📄 ΕΓΓΡΑΦΟ X to [ΕΓΓΡΑΦΟ X] */
    // Normalize plural: 📄 ΕΓΓΡΑΦΑ 2,4,6,7 → [ΕΓΓΡΑΦΟ 2][ΕΓΓΡΑΦΟ 4][ΕΓΓΡΑΦΟ 6][ΕΓΓΡΑΦΟ 7]
    let normalized = text.replace(/📄\s*\*{0,2}ΕΓΓΡΑΦΑ\s*([\d,\s]+)\*{0,2}/g, (m, nums) =>
      nums.split(',').map(n => `[ΕΓΓΡΑΦΟ ${n.trim()}]`).join(' ')
    );
    // Normalize singular: 📄 ΕΓΓΡΑΦΟ 3 → [ΕΓΓΡΑΦΟ 3]
    normalized = normalized.replace(/📄\s*\*{0,2}ΕΓΓΡΑΦΟ\s*(\d+)\*{0,2}/g, '[ΕΓΓΡΑΦΟ $1]');
    /* Split on [ΕΓΓΡΑΦΟ X] and **bold** */
    const parts = normalized.split(/(\[ΕΓΓΡΑΦΟ \d+(?:\|[a-f0-9]+)?\]|\*\*[^*]+\*\*)/g);
    return parts.map((part, i) => {
      /* Document reference */
      const docMatch = part.match(/\[ΕΓΓΡΑΦΟ (\d+)(?:\|([a-f0-9]+))?\]/);
      if (docMatch) {
        const docNum = parseInt(docMatch[1]);
        const docId = docMatch[2] || (results?.results?.[docNum-1]?.id);
        return (
          <span key={i} onClick={() => docId && setSelectedDoc(docId)} style={{
            color:'#2563EB',fontWeight:700,cursor:'pointer',
            background:'#EFF6FF',padding:'1px 6px',borderRadius:4,
            textDecoration:'underline',textDecorationStyle:'dotted',fontSize:12,
          }}
          onMouseEnter={e => { e.target.style.background='#DBEAFE'; }}
          onMouseLeave={e => { e.target.style.background='#EFF6FF'; }}
          title="Κλικ για πλήρες κείμενο"
          >📄 ΕΓΓΡΑΦΟ {docMatch[1]}</span>
        );
      }
      /* Bold text */
      const boldMatch = part.match(/^\*\*(.+)\*\*$/);
      if (boldMatch) {
        return <strong key={i} style={{color:'#1E293B'}}>{boldMatch[1]}</strong>;
      }
      return <span key={i}>{part}</span>;
    });
  }, [results, setSelectedDoc]);

  /* Render markdown-like headings + inline bold + clickable refs */
  const renderFormattedSummary = useCallback((text) => {
    if (!text) return null;
    const lines = text.split('\n');
    return lines.map((line, i) => {
      /* Section headers with emoji */
      if (/^[📌📋📚⚖️🔍💡⚠️]/.test(line.trim())) {
        const clean = line.replace(/\*\*/g,'');
        return <div key={i} style={{fontSize:15,fontWeight:700,color:'#0C4A6E',marginTop:14,marginBottom:6,borderBottom:'1px solid #E0F2FE',paddingBottom:4}}>{renderInline(clean)}</div>;
      }
      if (line.startsWith('### ') || line.startsWith('## ')) {
        const clean = line.replace(/^#{2,3}\s*/,'').replace(/\*\*/g,'');
        return <div key={i} style={{fontSize:14,fontWeight:700,color:'#1E293B',marginTop:10,marginBottom:4}}>{renderInline(clean)}</div>;
      }
      if (line.trim() === '') return <div key={i} style={{height:6}}/>;
      if (line.trim().startsWith('- ') || line.trim().startsWith('* ')) {
        return <div key={i} style={{paddingLeft:16,position:'relative',marginBottom:2}}><span style={{position:'absolute',left:4}}>•</span>{renderInline(line.replace(/^\s*[-*]\s*/,''))}</div>;
      }
      return <div key={i} style={{marginBottom:2}}>{renderInline(line)}</div>;
    });
  }, [renderInline]);


  const inp = {padding:'10px 14px',borderRadius:10,border:'1px solid #E2E8F0',fontSize:14,outline:'none'};

  return (
    <div style={{maxWidth:1000,margin:'0 auto',padding:24}}>
      
      {selectedDoc && <DocumentPopup docId={selectedDoc} onClose={() => setSelectedDoc(null)} />}

      {/* Header */}
      <div style={{marginBottom:24}}>
        <h2 style={{fontSize:22,fontWeight:700,color:'#1E293B',display:'flex',alignItems:'center',gap:10}}>
          ⚖️ ΝΟΜΟΚΡΑΤΙΑ AI Search
        </h2>
        <p style={{fontSize:14,color:'#64748B'}}>
          Αναζήτηση σε {stats ? stats.total.toLocaleString() : '3.500.000'}+ νομικά έγγραφα • Άρειος Πάγος • ΣτΕ • EUR-Lex • Διαύγεια • ΑΑΔΕ
        </p>
      </div>

      {/* Search Box */}
      <div style={{background:'#FFF',borderRadius:16,border:'1px solid #E2E8F0',padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.04)',marginBottom:20}}>
        <div className="ls-search-row" style={{display:'flex',flexWrap:'wrap',gap:12,marginBottom:16}}>
          <input
            type="text" value={query} onChange={e=>setQuery(e.target.value)}
            onKeyPress={handleKeyPress}
            className="ls-search-input" style={{...inp,flex:1,minWidth:0,fontSize:16,padding:'14px 18px'}}
            placeholder="π.χ. αναίρεση απόφασης, αποζημίωση τροχαίο, σύμβαση εργασίας..."
          />
          <button onClick={()=>guardedAction(handleSearch)} disabled={loading||!query.trim()} style={{
            padding:'14px 28px',borderRadius:12,
            background:loading?'#94A3B8':'linear-gradient(135deg,#1E293B,#334155)',
            color:'#FFF',fontSize:15,fontWeight:700,border:'none',cursor:loading?'wait':'pointer',
            whiteSpace:'nowrap',
          }}>
            {loading ? '⏳ Αναζήτηση...' : '🔍 Αναζήτηση'}
          </button>
        </div>

        {/* Filters */}
        <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap'}}>
          <div style={{display:'flex',alignItems:'center',gap:6}}>
            <span style={{fontSize:12,color:'#64748B'}}>Έτος:</span>
            <input type="number" value={yearFrom} onChange={e=>setYearFrom(e.target.value)} style={{...inp,width:80,fontSize:12,padding:'6px 10px'}} placeholder="από" min="1900" max="2026"/>
            <span style={{fontSize:12,color:'#94A3B8'}}>-</span>
            <input type="number" value={yearTo} onChange={e=>setYearTo(e.target.value)} style={{...inp,width:80,fontSize:12,padding:'6px 10px'}} placeholder="έως" min="1900" max="2026"/>
          </div>
          <select value={source} onChange={e=>setSource(e.target.value)} style={{...inp,fontSize:12,padding:'6px 10px',cursor:'pointer'}}>
            <option value="">Όλες οι πηγές</option>
            {sources.map(s=>(
              <option key={s.id} value={s.id}>{s.name || SOURCE_LABELS[s.id] || s.id} ({s.count.toLocaleString()})</option>
            ))}
          </select>
          <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12,color:'#475569',cursor:'pointer'}}>
            <input type="checkbox" checked={aiSummary} onChange={e=>setAiSummary(e.target.checked)} style={{accentColor:'#1E293B'}}/>
            🤖 AI Ανάλυση
          </label>
        </div>
      </div>

      {/* Error */}
      {error && <div style={{padding:16,borderRadius:12,background:'#FEF2F2',border:'1px solid #FECACA',color:'#991B1B',fontSize:14,marginBottom:16}}>❌ {error}</div>}

      {/* Loading */}
      {loading && (
        <div style={{textAlign:'center',padding:50}}>
          <div style={{display:'inline-flex',alignItems:'center',justifyContent:'center',position:'relative',width:64,height:64,marginBottom:16}}>
            <div style={{position:'absolute',width:64,height:64,borderRadius:'50%',background:'radial-gradient(circle,#2563EB 20%,transparent 70%)',animation:'aiPulse 1.5s ease-in-out infinite'}}/>
            <div style={{position:'absolute',width:48,height:48,borderRadius:'50%',background:'#FFF',display:'flex',alignItems:'center',justifyContent:'center',fontSize:24,boxShadow:'0 2px 12px rgba(37,99,235,0.2)'}}>⚖️</div>
          </div>
          <div style={{fontSize:16,fontWeight:600,color:'#1E293B',marginBottom:6}}>Αναζήτηση σε 3.5M+ νομικά έγγραφα</div>
          <div style={{fontSize:13,color:'#64748B',animation:'aiDots 1.5s steps(4,end) infinite'}}>Ανάλυση νομολογίας και εγγράφων...</div>
          {aiSummary && <div style={{fontSize:13,color:'#2563EB',marginTop:8,fontWeight:500}}>🤖 AI επεξεργάζεται την ανάλυση...</div>}
          <style>{'@keyframes aiPulse{0%,100%{transform:scale(1);opacity:0.6}50%{transform:scale(1.5);opacity:0.15}} @keyframes aiDots{0%{opacity:0.3}50%{opacity:1}100%{opacity:0.3}}'}</style>
        </div>
      )}

      {/* Results */}
      {results && !loading && (
        <div>
          {/* Summary bar */}
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
            <div style={{fontSize:14,color:'#475569'}}>
              <strong>{results.total_results}</strong> αποτελέσματα για <strong>"{results.query}"</strong>
              <span style={{fontSize:12,color:'#94A3B8',marginLeft:8}}>({results.search_time_ms}ms)</span>
            </div>
          </div>

          {/* AI Summary */}
<style>{`@keyframes nkSpin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
          {results.ai_summary && (
            <div style={{background:'linear-gradient(135deg,#F8FAFC,#F0F9FF)',borderRadius:14,padding:20,marginBottom:20,border:'1px solid #BAE6FD'}}>
              <div style={{fontSize:14,fontWeight:700,color:'#0C4A6E',marginBottom:10,display:'flex',alignItems:'center',gap:8}}>
                🤖 ΝΟΜΟΚΡΑΤΙΑ AI — Ανάλυση Νομολογίας
                <span style={{fontSize:11,fontWeight:400,color:'#64748B',fontStyle:'italic'}}>Κλικ στις παραπομπές για πλήρες κείμενο</span>
              </div>
              <div style={{fontSize:12,color:'#1E3A8A',background:'#EFF6FF',border:'1px solid #BFDBFE',borderRadius:8,padding:'6px 10px',marginBottom:10,fontWeight:600}}>
                🤖 Απάντηση από τεχνητή νοημοσύνη (AI) — επαληθεύστε πάντα τις πληροφορίες.
              </div>
              <div style={{fontSize:13,color:'#1E293B',lineHeight:1.8}}>
                {renderFormattedSummary(results.ai_summary)}
                {isStreaming && <div style={{display:"flex",alignItems:"center",gap:10,padding:"12px 0",borderTop:"1px solid #E2E8F0",marginTop:12}}><div style={{width:20,height:20,border:"3px solid #1E293B",borderRadius:"50%",borderTopColor:"transparent",animation:"nkSpin 1s linear infinite"}}></div><span style={{color:"#64748B",fontSize:13,fontStyle:"italic"}}>AI...</span></div>}
              </div>
              <div style={{marginTop:12,padding:'8px 12px',background:'#FEF3C7',borderRadius:8,fontSize:11,color:'#92400E'}}>

              </div>
              {/* 3 Action Buttons */}
              <div style={{display:'flex',gap:12,marginTop:16,flexWrap:'wrap'}}>
                <button onClick={() => setShowSaveModal(true)} style={{
                  padding:'12px 24px',borderRadius:10,background:'#059669',color:'#FFF',
                  fontSize:14,fontWeight:600,border:'none',cursor:'pointer',display:'flex',alignItems:'center',gap:8,
                  boxShadow:'0 2px 6px rgba(5,150,105,0.3)',transition:'all 0.2s'
                }}>💾 Αποθήκευση</button>
                <button onClick={() => { setShowChat(!showChat); }} style={{
                  padding:'12px 24px',borderRadius:10,background:'#2563EB',color:'#FFF',
                  fontSize:14,fontWeight:600,border:'none',cursor:'pointer',display:'flex',alignItems:'center',gap:8,
                  boxShadow:'0 2px 6px rgba(37,99,235,0.3)',transition:'all 0.2s'
                }}>💬 Ερωτήσεις επί της Ανάλυσης</button>
                <button onClick={() => { setResults(null); setQuery(''); setShowChat(false); setChatMessages([]); setSavedId(null); setSaveConfirm(''); }} style={{
                  padding:'12px 24px',borderRadius:10,background:'#64748B',color:'#FFF',
                  fontSize:14,fontWeight:600,border:'none',cursor:'pointer',display:'flex',alignItems:'center',gap:8,
                  boxShadow:'0 2px 6px rgba(100,116,139,0.3)',transition:'all 0.2s'
                }}>🔄 Νέα Αναζήτηση</button>
              </div>
              {/* Save confirmation */}
              {saveConfirm && <div style={{marginTop:8,padding:'8px 14px',background:'#D1FAE5',borderRadius:8,fontSize:12,color:'#065F46',fontWeight:600}}>{saveConfirm}</div>}
              {/* Save Modal */}
              {showSaveModal && (
                <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.4)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={() => setShowSaveModal(false)}>
                  <div style={{background:'#FFF',borderRadius:16,padding:28,maxWidth:450,width:'90%',boxShadow:'0 20px 60px rgba(0,0,0,0.2)'}} onClick={e => e.stopPropagation()}>
                    <div style={{fontSize:16,fontWeight:700,color:'#1E293B',marginBottom:16}}>💾 Αποθήκευση Ανάλυσης</div>
                    <div style={{fontSize:13,color:'#64748B',marginBottom:8}}>Όνομα υπόθεσης (προαιρετικό):</div>
                    <input value={caseName} onChange={e => setCaseName(e.target.value)} placeholder="π.χ. Ξενοδοχείο Κρήτης - Google Review" style={{width:'100%',padding:'10px 14px',borderRadius:10,border:'1px solid #E2E8F0',fontSize:14,marginBottom:16,outline:'none',boxSizing:'border-box'}} />
                    <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                      <button onClick={() => setShowSaveModal(false)} style={{padding:'10px 20px',borderRadius:8,background:'#F1F5F9',border:'1px solid #E2E8F0',fontSize:13,cursor:'pointer'}}>Ακύρωση</button>
                      <button onClick={async () => {
                        try {
                          const res = await fetch(API + '/api/search/history/save', {
                            method: 'POST', headers: {'Content-Type':'application/json'},
                            body: JSON.stringify({
                              query: query,
                              ai_summary: results.ai_summary,
                              documents: results.results.slice(0,5).map(r => ({title: r.title, excerpt: r.excerpt?.substring(0,2000) || '', source: r.source, decision_number: r.decision_number})),
                              case_name: caseName
                            })
                          });
                          const data = await res.json();
                          if (data.success) { setSavedId(data.id); setSaveConfirm('✅ Αποθηκεύτηκε επιτυχώς!'); setShowSaveModal(false); }
                        } catch(e) { console.error(e); }
                      }} style={{padding:'10px 20px',borderRadius:8,background:'#059669',color:'#FFF',border:'none',fontSize:13,fontWeight:600,cursor:'pointer'}}>Αποθήκευση</button>
                    </div>
                  </div>
                </div>
              )}
              {/* Chat Follow-Up */}
              {showChat && (
                <div style={{marginTop:16,borderTop:'2px solid #BAE6FD',paddingTop:16}}>
                  <div style={{fontSize:14,fontWeight:700,color:'#0C4A6E',marginBottom:12}}>💬 Ερωτήσεις επί της Ανάλυσης</div>
                  {chatMessages.map((msg, i) => (
                    <div key={i} style={{marginBottom:12,padding:'10px 14px',borderRadius:10,
                      background: msg.role === 'user' ? '#EFF6FF' : '#F0FDF4',
                      borderLeft: msg.role === 'user' ? '3px solid #2563EB' : '3px solid #059669',
                      fontSize:13,lineHeight:1.7,color:'#1E293B'
                    }}>
                      <div style={{fontSize:11,fontWeight:600,color: msg.role === 'user' ? '#2563EB' : '#059669',marginBottom:4}}>
                        {msg.role === 'user' ? '👤 Εσείς' : '🤖 ΝΟΜΟΚΡΑΤΙΑ AI'}
                      </div>
                      {msg.role === 'assistant' ? renderFormattedSummary(msg.content) : msg.content}
                    </div>
                  ))}
                  {chatLoading && (
                    <div style={{padding:16,display:'flex',alignItems:'center',gap:12}}>
                      <div style={{position:'relative',width:32,height:32}}>
                        <div style={{
                          position:'absolute',width:32,height:32,borderRadius:'50%',
                          background:'radial-gradient(circle,#2563EB 30%,transparent 70%)',
                          animation:'aiPulse 1.5s ease-in-out infinite'
                        }}/>
                        <div style={{
                          position:'absolute',top:4,left:4,width:24,height:24,borderRadius:'50%',
                          background:'#FFF',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14
                        }}>⚖️</div>
                      </div>
                      <div style={{fontSize:13,color:'#475569',fontWeight:500}}>
                        <span style={{animation:'aiDots 1.5s steps(4,end) infinite'}}>Ανάλυση ερωτήματος</span>
                        <span style={{animation:'aiDots 1.5s steps(4,end) infinite'}}>...</span>
                      </div>
                      <style>{'@keyframes aiPulse{0%,100%{transform:scale(1);opacity:0.7}50%{transform:scale(1.4);opacity:0.2}} @keyframes aiDots{0%{opacity:0.3}50%{opacity:1}100%{opacity:0.3}}'}</style>
                    </div>
                  )}
                  {chatMessages.length < 8 ? (
                    <div style={{display:'flex',gap:8}}>
                      <input value={chatInput} onChange={e => setChatInput(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter' && chatInput.trim() && !chatLoading) {
                          const q = chatInput.trim(); setChatInput(''); setChatLoading(true);
                          const newMsgs = [...chatMessages, {role:'user',content:q}]; setChatMessages(newMsgs);
                          fetch(API + '/api/search/chat', {
                            method:'POST', headers:{'Content-Type':'application/json', 'Authorization': 'Bearer '+(localStorage.getItem('token')||localStorage.getItem('nomokratia_token'))},
                            body: JSON.stringify({
                              query: query, ai_summary: results.ai_summary,
                              documents: results.results.slice(0,5).map(r => ({title:r.title,excerpt:r.excerpt?.substring(0,3000)||'',source:r.source})),
                              chat_history: newMsgs.slice(0,-1).map(m => ({role:m.role,content:m.content})),
                              follow_up: q
                            })
                          }).then(r=>r.json()).then(data => {
                            setChatLoading(false);
                            if (data.success) setChatMessages(prev => [...prev, {role:'assistant',content:data.answer}]);
                          }).catch(() => setChatLoading(false));
                        }}}
                        placeholder="Ρωτήστε σχετικά με την ανάλυση..."
                        style={{flex:1,padding:'10px 14px',borderRadius:10,border:'1px solid #E2E8F0',fontSize:13,outline:'none'}} />
                      <button onClick={() => {
                        if (!chatInput.trim() || chatLoading) return;
                        const q = chatInput.trim(); setChatInput(''); setChatLoading(true);
                        const newMsgs = [...chatMessages, {role:'user',content:q}]; setChatMessages(newMsgs);
                        fetch(API + '/api/search/chat', {
                          method:'POST', headers:{'Content-Type':'application/json', 'Authorization': 'Bearer '+(localStorage.getItem('token')||localStorage.getItem('nomokratia_token'))},
                          body: JSON.stringify({
                            query: query, ai_summary: results.ai_summary,
                            documents: results.results.slice(0,5).map(r => ({title:r.title,excerpt:r.excerpt?.substring(0,3000)||'',source:r.source})),
                            chat_history: newMsgs.slice(0,-1).map(m => ({role:m.role,content:m.content})),
                            follow_up: q
                          })
                        }).then(r=>r.json()).then(data => {
                          setChatLoading(false);
                          if (data.success) setChatMessages(prev => [...prev, {role:'assistant',content:data.answer}]);
                        }).catch(() => setChatLoading(false));
                      }} style={{padding:'10px 20px',borderRadius:10,background:'#2563EB',color:'#FFF',border:'none',fontSize:13,fontWeight:600,cursor:'pointer'}}>Αποστολή</button>
                    </div>
                  ) : <div style={{fontSize:12,color:'#92400E',background:'#FEF3C7',padding:8,borderRadius:8}}>Μέγιστος αριθμός ερωτήσεων (8). Αποθηκεύστε ή ξεκινήστε νέα αναζήτηση.</div>}
                </div>
              )}
            </div>
          )}

          {/* Results list */}
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:600,color:'#475569'}}>📚 Σχετικότερες Αποφάσεις</div>
            {results.results.length > 5 && (
              <button onClick={() => setShowAllResults(!showAllResults)} style={{
                fontSize:12,color:'#2563EB',background:'none',border:'none',cursor:'pointer',fontWeight:600,
              }}>{showAllResults ? '▲ Λιγότερα' : `▼ Εμφάνιση όλων (${results.results.length})`}</button>
            )}
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:10}}>
            {(showAllResults ? results.results : results.results.slice(0,5)).map((r,i) => {
              const sc = SOURCE_COLORS[r.source_category] || {bg:'#F1F5F9',color:'#475569',border:'#E2E8F0'};
              return (
                <div key={r.id} style={{
                  background:'#FFF',borderRadius:14,border:'1px solid #E2E8F0',padding:18,
                  transition:'all 0.2s',cursor:'pointer',
                }}
                onClick={() => { if(r.url) window.open(r.url,'_blank'); else setSelectedDoc(r.id || `idx-${i}`); }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#3B82F6'; e.currentTarget.style.boxShadow='0 4px 12px rgba(59,130,246,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='#E2E8F0'; e.currentTarget.style.boxShadow='none'; }}
                >
                  <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:12}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:14,fontWeight:600,color:'#1E293B',lineHeight:1.5,marginBottom:6}}>
                        {r.title}
                      </div>
                      <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center',marginBottom:8}}>
                        <span style={{fontSize:11,padding:'2px 8px',borderRadius:6,background:sc.bg,color:sc.color,fontWeight:700,border:`1px solid ${sc.border}`}}>
                          {SOURCE_LABELS[r.source_category] || r.source || r.source_category}
                        </span>
                        {r.decision_number && (
                          <span style={{fontSize:11,padding:'2px 8px',borderRadius:6,background:'#EFF6FF',color:'#2563EB',fontWeight:600}}>
                            📋 {r.decision_number}
                          </span>
                        )}
                        {r.year && (
                          <span style={{fontSize:11,padding:'2px 8px',borderRadius:6,background:'#F0FDF4',color:'#059669',fontWeight:600}}>
                            {r.year}
                          </span>
                        )}
                        <span style={{fontSize:11,color:'#CBD5E1'}}>
                          ★ {(r.relevance || 0).toFixed(1)}
                        </span>
                      </div>
                      {r.excerpt && (
                        <div style={{fontSize:12,color:'#64748B',lineHeight:1.6,maxHeight:60,overflow:'hidden'}}>
                          {r.excerpt.substring(0, 200)}...
                        </div>
                      )}
                    </div>
                    <div style={{display:'flex',flexDirection:'column',gap:4,alignItems:'flex-end',flexShrink:0}}>
                      {r.url ? (
                        <a href={r.url} target="_blank" rel="noopener noreferrer" 
                          onClick={e => e.stopPropagation()}
                          style={{fontSize:11,color:'#3B82F6',fontWeight:600,display:'flex',alignItems:'center',gap:4,textDecoration:'none'}}>
                          📖 Πλήρες κείμενο →
                        </a>
                      ) : (
                        <span onClick={e => { e.stopPropagation(); setSelectedDoc(r.id || `idx-${i}`); }}
                          style={{fontSize:11,color:'#64748B',fontWeight:600,display:'flex',alignItems:'center',gap:4,cursor:'pointer'}}>
                          📄 Προβολή αποσπάσματος
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {results.total_results === 0 && (
            <div style={{textAlign:'center',padding:40,color:'#94A3B8'}}>
              <div style={{fontSize:40,marginBottom:12}}>🔍</div>
              <div style={{fontSize:16}}>Δεν βρέθηκαν αποτελέσματα</div>
              <div style={{fontSize:13,marginTop:4}}>Δοκιμάστε διαφορετικούς όρους αναζήτησης</div>
            </div>
          )}
        </div>
      )}

      {/* Empty state */}
      {!results && !loading && (
        <div style={{textAlign:'center',padding:60,color:'#94A3B8'}}>
          <div style={{fontSize:50,marginBottom:16}}>⚖️</div>
          <div style={{fontSize:18,fontWeight:600,color:'#64748B',marginBottom:8}}>
            Αναζητήστε σε 3.5M+ νομικά έγγραφα
          </div>
          <div style={{fontSize:13,maxWidth:500,margin:'0 auto',lineHeight:1.6,color:'#94A3B8'}}>
            Άρειος Πάγος (46.000+) • ΣτΕ (8.800+) • Διαύγεια (3.5M) • EUR-Lex • ΑΑΔΕ • ΦΕΚ • Βουλή
          </div>
          <div style={{display:'flex',gap:8,justifyContent:'center',marginTop:20,flexWrap:'wrap'}}>
            {['αναίρεση απόφασης','αποζημίωση τροχαίο','σύμβαση εργασίας','έξωση μισθωτή','φορολογικός έλεγχος','ποινική δίωξη'].map(s=>(
              <button key={s} onClick={()=>{setQuery(s);}} style={{
                padding:'8px 16px',borderRadius:8,background:'#F1F5F9',border:'1px solid #E2E8F0',
                fontSize:12,color:'#475569',cursor:'pointer',transition:'all 0.2s',
              }}
              onMouseEnter={e => { e.target.style.background='#E2E8F0'; }}
              onMouseLeave={e => { e.target.style.background='#F1F5F9'; }}
              >{s}</button>
            ))}
          </div>
        </div>
      )}

      {showPricing && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.7)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}} onClick={()=>setShowPricing(false)}>
          <div style={{background:'#fff',borderRadius:'16px',maxWidth:'900px',width:'100%',maxHeight:'90vh',overflow:'auto',padding:'40px'}} onClick={e=>e.stopPropagation()}>
            <div style={{textAlign:'center',marginBottom:'32px'}}>
              <h2 style={{fontSize:'28px',fontWeight:'700',color:'#1a365d',marginBottom:'8px'}}>🔒 Απαιτείται Εγγραφή</h2>
              <p style={{color:'#4a5568',fontSize:'16px'}}>Εγγραφείτε δωρεάν και αποκτήστε πρόσβαση σε 3.5M+ νομικά έγγραφα</p>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'20px',marginBottom:'24px'}}>
              <div style={{border:'1px solid #e2e8f0',borderRadius:'12px',padding:'24px',textAlign:'center'}}>
                <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1a365d'}}>Δοκιμαστικό</h3>
                <div style={{fontSize:'32px',fontWeight:'700',color:'#2d3748',margin:'12px 0'}}>Δωρεάν</div>
                <p style={{color:'#718096',fontSize:'14px',marginBottom:'16px'}}>14 ημέρες πλήρης πρόσβαση</p>
                <div style={{textAlign:'left',fontSize:'13px',color:'#4a5568',lineHeight:'2'}}>
                  ✅ AI Νομική Αναζήτηση σε 3.5M+ έγγραφα<br/>
                  ✅ AI Ανάλυση Νομολογίας<br/>
                  ✅ 10 AI αναλύσεις / ημέρα<br/>
                  ✅ Πλήρες CRM — Πελάτες, Υποθέσεις<br/>
                  ✅ Χρονοχρέωση & Προθεσμίες<br/>
                  ✅ Εισαγωγή από CSV/Excel<br/>
                  ✅ Χωρίς πιστωτική κάρτα
                </div>
                <button onClick={()=>window.location.href='/?register=true'} style={{width:'100%',marginTop:'16px',padding:'12px',background:'#2b6cb0',color:'#fff',border:'none',borderRadius:'8px',fontSize:'15px',fontWeight:'600',cursor:'pointer'}}>Ξεκινήστε Δωρεάν</button>
              </div>
              <div style={{border:'2px solid #1a365d',borderRadius:'12px',padding:'24px',textAlign:'center',position:'relative'}}>
                <div style={{position:'absolute',top:'-12px',left:'50%',transform:'translateX(-50%)',background:'#1a365d',color:'#fff',padding:'4px 16px',borderRadius:'20px',fontSize:'12px',fontWeight:'600'}}>Δημοφιλές</div>
                <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1a365d'}}>Επαγγελματικό</h3>
                <div style={{fontSize:'32px',fontWeight:'700',color:'#2d3748',margin:'12px 0'}}>€199<span style={{fontSize:'16px',fontWeight:'400',color:'#718096'}}>/μήνα</span></div>
                <p style={{color:'#718096',fontSize:'14px',marginBottom:'16px'}}>Για δικηγόρους & ατομικά γραφεία</p>
                <div style={{textAlign:'left',fontSize:'13px',color:'#4a5568',lineHeight:'2'}}>
                  ✅ Απεριόριστες AI Αναλύσεις<br/>
                  ✅ AI Δημιουργία 18 τύπων εγγράφων<br/>
                  ✅ AADE / myDATA Τιμολόγηση<br/>
                  ✅ Έλεγχος Σύγκρουσης Συμφερόντων<br/>
                  ✅ Χρονοχρέωση & Τιμολόγηση<br/>
                  ✅ Προθεσμίες με Υπενθυμίσεις<br/>
                  ✅ AI Insights & Στατιστικά
                </div>
                <button onClick={()=>window.location.href='/?register=true'} style={{width:'100%',marginTop:'16px',padding:'12px',background:'#1a365d',color:'#fff',border:'none',borderRadius:'8px',fontSize:'15px',fontWeight:'600',cursor:'pointer'}}>Ξεκινήστε Τώρα</button>
              </div>
              <div style={{border:'1px solid #e2e8f0',borderRadius:'12px',padding:'24px',textAlign:'center'}}>
                <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1a365d'}}>Δικηγορικό Γραφείο</h3>
                <div style={{fontSize:'28px',fontWeight:'700',color:'#2d3748',margin:'12px 0'}}>Κατόπιν επικ.</div>
                <p style={{color:'#718096',fontSize:'14px',marginBottom:'16px'}}>Για γραφεία με 2+ δικηγόρους</p>
                <div style={{textAlign:'left',fontSize:'13px',color:'#4a5568',lineHeight:'2'}}>
                  ✅ Όλα τα Επαγγελματικού<br/>
                  ✅ Έως 10 δικηγόροι / γραφείο<br/>
                  ✅ Κεντρική Διαχείριση Υποθέσεων<br/>
                  ✅ Cloud Sync (Drive, OneDrive)<br/>
                  ✅ API Access & Integrations<br/>
                  ✅ Priority Support & Εκπαίδευση
                </div>
                <button onClick={()=>window.location.href='mailto:info@nomokratia.ai?subject=Εταιρικό Πλάνο'} style={{width:'100%',marginTop:'16px',padding:'12px',background:'#fff',color:'#1a365d',border:'2px solid #1a365d',borderRadius:'8px',fontSize:'15px',fontWeight:'600',cursor:'pointer'}}>Επικοινωνήστε</button>
              </div>
            </div>
            <p style={{textAlign:'center',color:'#a0aec0',fontSize:'13px'}}>Χωρίς δέσμευση • Ακύρωση ανά πάσα στιγμή • Άμεση ενεργοποίηση</p>
            <button onClick={()=>setShowPricing(false)} style={{display:'block',margin:'16px auto 0',background:'none',border:'none',color:'#718096',cursor:'pointer',fontSize:'14px'}}>✕ Κλείσιμο</button>
          </div>
        </div>
      )}

      {showPricing && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.7)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}} onClick={()=>setShowPricing(false)}>
          <div style={{background:'#fff',borderRadius:'16px',maxWidth:'900px',width:'100%',maxHeight:'90vh',overflow:'auto',padding:'40px'}} onClick={e=>e.stopPropagation()}>
            <div style={{textAlign:'center',marginBottom:'32px'}}>
              <h2 style={{fontSize:'28px',fontWeight:'700',color:'#1a365d',marginBottom:'8px'}}>🔒 Απαιτείται Εγγραφή</h2>
              <p style={{color:'#4a5568',fontSize:'16px'}}>Εγγραφείτε δωρεάν και αποκτήστε πρόσβαση σε 3.5M+ νομικά έγγραφα</p>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'20px',marginBottom:'24px'}}>
              <div style={{border:'1px solid #e2e8f0',borderRadius:'12px',padding:'24px',textAlign:'center'}}>
                <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1a365d'}}>Δοκιμαστικό</h3>
                <div style={{fontSize:'32px',fontWeight:'700',color:'#2d3748',margin:'12px 0'}}>Δωρεάν</div>
                <p style={{color:'#718096',fontSize:'14px',marginBottom:'16px'}}>14 ημέρες πλήρης πρόσβαση</p>
                <div style={{textAlign:'left',fontSize:'13px',color:'#4a5568',lineHeight:'2'}}>
                  ✅ AI Νομική Αναζήτηση σε 3.5M+ έγγραφα<br/>
                  ✅ AI Ανάλυση Νομολογίας<br/>
                  ✅ 10 AI αναλύσεις / ημέρα<br/>
                  ✅ Πλήρες CRM — Πελάτες, Υποθέσεις<br/>
                  ✅ Χρονοχρέωση & Προθεσμίες<br/>
                  ✅ Εισαγωγή από CSV/Excel<br/>
                  ✅ Χωρίς πιστωτική κάρτα
                </div>
                <button onClick={()=>window.location.href='/?register=true'} style={{width:'100%',marginTop:'16px',padding:'12px',background:'#2b6cb0',color:'#fff',border:'none',borderRadius:'8px',fontSize:'15px',fontWeight:'600',cursor:'pointer'}}>Ξεκινήστε Δωρεάν</button>
              </div>
              <div style={{border:'2px solid #1a365d',borderRadius:'12px',padding:'24px',textAlign:'center',position:'relative'}}>
                <div style={{position:'absolute',top:'-12px',left:'50%',transform:'translateX(-50%)',background:'#1a365d',color:'#fff',padding:'4px 16px',borderRadius:'20px',fontSize:'12px',fontWeight:'600'}}>Δημοφιλές</div>
                <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1a365d'}}>Επαγγελματικό</h3>
                <div style={{fontSize:'32px',fontWeight:'700',color:'#2d3748',margin:'12px 0'}}>€199<span style={{fontSize:'16px',fontWeight:'400',color:'#718096'}}>/μήνα</span></div>
                <p style={{color:'#718096',fontSize:'14px',marginBottom:'16px'}}>Για δικηγόρους & ατομικά γραφεία</p>
                <div style={{textAlign:'left',fontSize:'13px',color:'#4a5568',lineHeight:'2'}}>
                  ✅ Απεριόριστες AI Αναλύσεις<br/>
                  ✅ AI Δημιουργία 18 τύπων εγγράφων<br/>
                  ✅ AADE / myDATA Τιμολόγηση<br/>
                  ✅ Έλεγχος Σύγκρουσης Συμφερόντων<br/>
                  ✅ Χρονοχρέωση & Τιμολόγηση<br/>
                  ✅ Προθεσμίες με Υπενθυμίσεις<br/>
                  ✅ AI Insights & Στατιστικά
                </div>
                <button onClick={()=>window.location.href='/?register=true'} style={{width:'100%',marginTop:'16px',padding:'12px',background:'#1a365d',color:'#fff',border:'none',borderRadius:'8px',fontSize:'15px',fontWeight:'600',cursor:'pointer'}}>Ξεκινήστε Τώρα</button>
              </div>
              <div style={{border:'1px solid #e2e8f0',borderRadius:'12px',padding:'24px',textAlign:'center'}}>
                <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1a365d'}}>Δικηγορικό Γραφείο</h3>
                <div style={{fontSize:'28px',fontWeight:'700',color:'#2d3748',margin:'12px 0'}}>Κατόπιν επικ.</div>
                <p style={{color:'#718096',fontSize:'14px',marginBottom:'16px'}}>Για γραφεία με 2+ δικηγόρους</p>
                <div style={{textAlign:'left',fontSize:'13px',color:'#4a5568',lineHeight:'2'}}>
                  ✅ Όλα τα Επαγγελματικού<br/>
                  ✅ Έως 10 δικηγόροι / γραφείο<br/>
                  ✅ Κεντρική Διαχείριση Υποθέσεων<br/>
                  ✅ Cloud Sync (Drive, OneDrive)<br/>
                  ✅ API Access & Integrations<br/>
                  ✅ Priority Support & Εκπαίδευση
                </div>
                <button onClick={()=>window.location.href='mailto:info@nomokratia.ai?subject=Εταιρικό Πλάνο'} style={{width:'100%',marginTop:'16px',padding:'12px',background:'#fff',color:'#1a365d',border:'2px solid #1a365d',borderRadius:'8px',fontSize:'15px',fontWeight:'600',cursor:'pointer'}}>Επικοινωνήστε</button>
              </div>
            </div>
            <p style={{textAlign:'center',color:'#a0aec0',fontSize:'13px'}}>Χωρίς δέσμευση • Ακύρωση ανά πάσα στιγμή • Άμεση ενεργοποίηση</p>
            <button onClick={()=>setShowPricing(false)} style={{display:'block',margin:'16px auto 0',background:'none',border:'none',color:'#718096',cursor:'pointer',fontSize:'14px'}}>✕ Κλείσιμο</button>
          </div>
        </div>
      )}
    </div>
  );
};
export default LegalSearch;
